import React, { Fragment } from "react";

// import microsoftLogo from "../assets/images/logos/microsoft_logo.svg"
import facebookLogo from "../assets/images/logos/facebook_logo.svg";
import discordLogo from "../assets/images/logos/discord_logo.svg";
import facebookgroupLogo from "../assets/images/logos/facebookgroup_logo.svg";
// import instagramLogo from "../assets/images/logos/instagram_logo.svg"
// import twitterLogo from "../assets/images/logos/twitter_logo.svg"
import youtubeLogo from "../assets/images/logos/youtube_logo.svg";
import githubLogo from "../assets/images/logos/github_logo.svg";
import "../css/Footer.css";

// const PRIVACY_POLICY = "https://go.microsoft.com/fwlink/?LinkId=521839"
// const TERMS_OF_USE = "https://go.microsoft.com/fwlink/?LinkID=206977"
// const MICROSOFT = "https://www.microsoft.com/en-nz"

const SOCIAL_MEDIA = [
  {
    name: "Facebook",
    url: "https://www.facebook.com/studentaccelerator/",
    logo: facebookLogo,
  },
  {
    name: "Discord",
    url: "https://discord.gg/c4Y5SAZ",
    logo: discordLogo,
  },
  {
    name: "Facebook Group",
    url: "https://www.facebook.com/groups/msaccelerator/",
    logo: facebookgroupLogo,
  },
  {
    name: "YouTube",
    url: "https://www.youtube.com/channel/UCCegNuS_AZjK-P3ZMN3JXNw",
    logo: youtubeLogo,
  },
  {
    name: "GitHub",
    url: "https://github.com/nzmsa",
    logo: githubLogo,
  },
];

function Footer() {
  return (
    <footer className="page-footer font-small cyan darken-3 footer row">
      <div className="center col-lg-7 pl-lg-5 copyright-text">
        <div className="desktop-footer-copyright">
          {/* <a href={MICROSOFT}>
            <img className="footer-logo" src={microsoftLogo} height="20px" alt="Microsoft Logo" />
          </a> */}
          <span className="pl-lg-3 pl-2">
            Copyright © Microsoft Student Accelerator, 2026. All rights reserved
          </span>
        </div>
        <div className="tablet-footer-copyright">
          {/* <a href={MICROSOFT}>
            <img className="footer-logo" src={microsoftLogo} height="20px" alt="Microsoft Logo" />
          </a> */}
          <span className="pl-lg-3 pl-2">© MSA 2026</span>
          {/* <a href={PRIVACY_POLICY} className="pl-3">Privacy policy</a> */}
          {/* <a href={TERMS_OF_USE} className="pl-3">Terms of use</a> */}
        </div>
        <div className="mobile-footer-copyright">
          <span className="pl-lg-3 pl-2">© MSA 2026</span>
          {/* <a href={PRIVACY_POLICY} className="pl-3">Privacy policy</a> */}
          {/* <a href={TERMS_OF_USE} className="pl-3">Terms of use</a> */}
        </div>
      </div>

      <div className="center col-lg-5">
        {SOCIAL_MEDIA.map((social: any, key: number) => {
          return <Fragment key={key}>{FooterSocialIcon(social)}</Fragment>;
        })}
      </div>
    </footer>
  );
}

function FooterSocialIcon(props: any) {
  return (
    <span className="social-media-icon">
      <a href={props.url}>
        <img
          className="footer-logo"
          src={props.logo}
          height="20px"
          alt={props.name}
        />
      </a>
    </span>
  );
}

export default Footer;
